import { getString } from "common/ui_string_labels/ui-strings-utils";
import { JSX } from "react";
import { Link, LinkProps } from "@amzn/awsui-components-react";
import { ErrorProps } from "interfaces";

/**
 * Base path for error-related string keys
 */
const getStringPath: string = "errors";

/**
 * Path for CTI-specific error string keys
 */
const ctiGetStringPath: string = `${getStringPath}.cti`;

/**
 * Header text for CTI-related errors
 */
export const ctiErrorHeader: string = getString(`${getStringPath}.unexpected`);

/**
 * Main error message for CTI failures
 */
export const ctiErrorMessage: string = getString(`${ctiGetStringPath}.message`);

/**
 * Text for the cut ticket link message
 */
export const cutTicketMessage: string = getString(`${ctiGetStringPath}.cutTicketMessage`);

/**
 * The URL for the cut ticket form
 */
export const ctiURL: string =
    "https://t.corp.amazon.com/create/options?category=IT%20Asset%20Management&type=Ordering%20Services&item=ITSE%20Website&group=kumo-its-manatee";

/**
 * Renders the error content when getAllCatalogItems fails
 *
 * @param {LinkProps.Color | undefined} [color] - Optional color variant for the link component
 * @return {JSX.Element} - A message with a link to cut a ticket
 */
export const GetCatalogErrorContent = (color: LinkProps.Color | undefined = undefined): JSX.Element => {
    return (
        <>
            {ctiErrorMessage + " "}
            <Link href={ctiURL} variant="primary" color={color} external>
                {cutTicketMessage}
            </Link>
        </>
    );
};

/**
 * CTI error configuration object containing header and content for catalog item errors
 */
export const CTI_ERROR: ErrorProps = {
    name: ctiErrorHeader,
    content: GetCatalogErrorContent(),
};
